/**
 * Alerta acessível. Usa `role="alert"` para tons de erro/aviso (anunciado por
 * leitores de tela) e `role="status"` para info/sucesso.
 */
import type { ReactNode } from "react";

import { AlertIcon, CheckIcon } from "./Icons";

type Tone = "error" | "warning" | "info" | "success";

interface AlertProps {
  readonly tone: Tone;
  readonly title?: string;
  readonly children: ReactNode;
}

export function Alert({ tone, title, children }: AlertProps) {
  const role = tone === "error" || tone === "warning" ? "alert" : "status";
  const Icon = tone === "success" ? CheckIcon : AlertIcon;
  return (
    <div className={`mp-alert mp-alert--${tone}`} role={role}>
      <span className="mp-alert__icon">
        <Icon size={20} />
      </span>
      <div className="mp-alert__body">
        {title ? <p className="mp-alert__title">{title}</p> : null}
        <div className="mp-alert__text">{children}</div>
      </div>
    </div>
  );
}
